import React from 'react';
import { useShallow } from 'zustand/react/shallow';

import SiteLogo from '../../_application/site-logo';
import Login from '../../_application/login';
import Totaliser from '../common/totalizer';
import AddToCartControls from '../common/add-to-cart-controls';

import { usePrintsOrderStore } from '../stores/use-prints-order-store';
import { usePrintsConfigStore } from '../stores/use-prints-config-store';
import { usePrintsUiStore } from '../stores/use-prints-ui-store';
import { selectSizesWithPhotos, selectHasPrints } from '../stores/selectors';
import { useSelectedDeliveryOption } from '../hooks/use-selected-delivery-option';

const PrintsBuilderHeader = () => {
  // --- STATE ---
  const currentlyLoading = usePrintsUiStore((state) => state.currentlyLoading);
  const urls = usePrintsConfigStore((state) => state.urls);
  const allSizes = usePrintsConfigStore((state) => state.allSizes);

  const photos = usePrintsOrderStore((state) => state.photos);
  const { handleAddToCart } = usePrintsOrderStore(
    useShallow((state) => ({
      handleAddToCart: state.handleAddToCart,
    })),
  );

  // --- SELECTORS ---
  const sizesWithPhotos = selectSizesWithPhotos(allSizes, photos);
  const hasPrints = selectHasPrints(photos);

  const deliveryOption = useSelectedDeliveryOption();

  return (
    <header className="prints-builder__header d-flex align-items-center">
      <div className="flex-grow-1">
        <SiteLogo />
      </div>
      <div className="flex-shrink-0 d-flex align-items-center justify-content-end h-100">
        <Login />
        <Totaliser sizes={sizesWithPhotos} deliveryOption={deliveryOption} />
        <AddToCartControls
          enabled={hasPrints && !currentlyLoading}
          basketUrl={urls.cart_page}
          onAddToCart={handleAddToCart}
        />
      </div>
    </header>
  );
};

export default PrintsBuilderHeader;
